var partnershipsformatlevels = {
    list: function(page){
        var params = {
            page: (page || 1),
            countryID : $('#countryID').val(),
            outsourced: ($('#outsourced').prop('checked') == true ? 1 : 0)
        };

        var getParams = location.pathname+"?"+($.param(params));

        if(window.history && window.history.replaceState)
        {
            window.history.replaceState(null, null, getParams);

            $.get(getParams, params, function(resp){
                $('#partnerships-formatlevels').html(resp);
            });
        } else {
            location.href=getParams;
        }
    },

    stateChange: function(chObj){
        var params = {
            partnershipID: chObj.data('partnershipid'),
            partnershipformat_name: chObj.data('partnershipformat_name'),
            state: chObj.data('state'),
            unit: chObj.data('unit'),
        };

        $.post('/partnership/partnershipsFormatLevels/stateChange', params, function(){});
    },
};